import { Link } from 'react-router-dom';

import ForgotPasswordForm from '../../forms/forgotPassword';

import brand from '../../../assets/images/brand.png';
import motif from '../../../assets/images/motif.png';

import classNames from './auth.module.scss';
import routes from '../../../utils/routes';

const ForgotPassword = () => {
	return (
		<div className={classNames.newLogin}>
			<div className={classNames.newLoginInner}>
				<div className={classNames.newLoginLeft}>
					<div className={classNames.newLoginLeftBrand}>
						<Link to={routes.home.pathname}>
							<img src={brand} alt="Arridex Brand" loading="lazy" />
						</Link>
					</div>

					<div className="divider my-5"></div>

					<h3>Reset Password</h3>

					<p>
						Enter the email address associated with your account and we’ll send
						an email with instructions to reset your password
					</p>

					<div className="divider my-5"></div>

					<ForgotPasswordForm />
				</div>

				<div className={classNames.newLoginRight}>
					<img src={motif} alt="Motif" loading="lazy" />
				</div>
			</div>
		</div>
	);
};

export default ForgotPassword;
